export default function RcmpArrowRightSingleAccordion(props) {
  return (
    <svg
      width="10"
      height="17"
      viewBox="0 0 10 17"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill={props.fill || "#415364"}
    >
      <path
        d="M2.23448 0.571234L9.04858 7.68229C9.21409 7.85359 9.29628 8.07581 9.29628 8.29689C9.29628 8.51796 9.21409 8.74015 9.04858 8.91144L2.23448 16.0225C1.89552 16.3778 1.333 16.3894 0.978847 16.0491C0.622365 15.7112 0.610772 15.1464 0.952218 14.7933L7.1762 8.29689L0.952217 1.80039C0.610772 1.44853 0.622364 0.882568 0.978847 0.544604C1.333 0.204344 1.89552 0.2159 2.23448 0.571234Z"
        
      />
    </svg>
  )
}
